import axios from "axios";
import { accessToken, API_URL } from "../../constants/config";

export const getAllExternalDocs = async (data, accessToken) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/api/v1/external_docs`,
    headers: {
      "Content-Type": "application/json",
      Authorization: null,
      "Access-Token": `${accessToken}`,
    },
    data: data,
  };

  try {
    const externalDocs = await axios.request(config);
    let data = externalDocs?.data?.data;
    return Object.values(data);
  } catch (error) {
    console.log(error);
  }
};

export const getSingleExternalDocs = async (data, accessToken) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/api/v1/single_external_doc`,
    headers: {
      "Content-Type": "application/json",
      Authorization: null,
      "Access-Token": `${accessToken}`,
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response?.data?.data;
  } catch (err) {
    console.log(err);
  }
};

export const externalDocsMutation = async (formData, accessToken, trigger) => {
  // Send POST request with Axios
  let url;
  if (trigger === "Edit") {
    url = `${API_URL}/api/v1/update_external_docs`;
  } else {
    url = `${API_URL}/api/v1/store_external_docs`;
  }
  try {
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: null,
        "Access-Token": `${accessToken}`,
      },
    });

    return response.data.status == 200 ? true : false;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const deleteExternalDoc = async (data, accessToken) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/api/v1/delete_external_doc`,
    headers: {
      "Content-Type": "application/json",
      Authorization: null,
      "Access-Token": `${accessToken}`,
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    if (response.data.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log("Error:", err);
  }
};
